// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__uJ6KM","innerContainer":"Projects_innerContainer__fzPfs"};